export class FoundationNavigationModule {
    static get HomePage(): string { return 'app.foundation.homepage'; }
    static get Engineers(): string { return 'app.foundation.engineers'; }
    static get Commissioning(): string { return `app.foundation.commissioning` }
    static get NewCommissionWithBindings(): string { return `${FoundationNavigationModule.Commissioning}.new` }
    static get NewCommissionNoBindings(): string { return "app.foundation.newcommission" }
    static get ViewCommission(): string { return `${FoundationNavigationModule.Commissioning}.view` }
    static get NPS(): string { return 'app.foundation.nps'; }

    static get DeveloperConsole(): string { return 'app.foundation.console' }
    static get ConfigManager(): string { return 'app.foundation.configmanager' }
    static get AppManager(): string { return 'app.foundation.appmanager' }
    static get CameraConfig(): string { return 'app.foundation.cameraconfig' }

    static get Customers(): string { return 'app.foundation.customers'; }
    static get CustomerView(): string { return `${FoundationNavigationModule.Customers}.view`; }
    static get CustomerEdit(): string { return `${FoundationNavigationModule.Customers}.edit`; }
    static get CustomerNew(): string { return `${FoundationNavigationModule.Customers}.new`; }
   
    static get CustomerSubscriptions(): string { return `app.foundation.subscriptions`; }

    static get ReleaseNotes(): string { return `${FoundationNavigationModule.ParentRoot}.releasenotes`; }

    static get Vehicles(): string { return 'app.foundation.vehicles'; }
    static get VehicleView(): string { return `${FoundationNavigationModule.Vehicles}.view`; }

    static get DeviceHealth(): string { return 'app.foundation.devicehealth'; }

    static get DeviceHealthVehicleView(): string { return `${FoundationNavigationModule.DeviceHealth}.vehicle`; }


    static get DeviceHealthCompanies(): string { return 'app.foundation.devicehealth.companies'; }


    static get Units(): string { return `app.foundation.units` }
    static get Peripherals(): string { return `app.foundation.peripherals` }
    static get Cameras(): string { return `app.foundation.cameras` }
    static get CamerasVideo(): string { return `app.foundation.cameras.view.video` }
    static get Sims(): string { return `app.foundation.sims` }
    static get RVLite(): string { return `app.foundation.rvlite` }

    static get StreamaxConfigsAccountList(): string { return `app.foundation.streamaxconfigs` }
    static get StreamaxConfigsAccountView(): string { return `${FoundationNavigationModule.StreamaxConfigsAccountList}.accountview` }

    static get Jobs(): string { return 'app.foundation.jobs'; }
    static get JobItems(): string { return 'app.foundation.jobitems'; }
    static get EngineerHistory(): string { return 'app.foundation.engineerhistory'; }
    static get JobItemsCommissionNew(): string { return `${FoundationNavigationModule.JobItems}.new`; }
    static get JobView(): string { return 'app.foundation.jobs.view'; }
    static get VisitFailures(): string { return 'app.foundation.visitfailures' }

    static get Default(): string { return FoundationNavigationModule.Customers; }
    static get DefaultEngineer(): string { return FoundationNavigationModule.JobItems; }
    static get DefaultHardware(): string { return this.Units; }
    static get ParentRoot(): string { return "app.foundation"; }
}
